import SectionHeader  from "../components/SectionHeader";
import TextWrapper from "./TextWrapper";
import VariantWrapper from "./VariantWrapper";
import {
    CAROUSEL_ITEM_HEADER_HEIGHT,
    CAROUSEL_ITEM_PADDING
} from "../PosterChapter.constants";
import { GradualSpacing } from '../../../effects/GradualSpacing';
import ServiceHubPosterChapterData from '../PosterChapter.interface';
import { usePosterTitle } from './usePosterTitle.hook';

export default function LayoutVariant1(props: ServiceHubPosterChapterData) {
    const { subtitle, is_show_date, headline } = props;

    const computedTitleSize = usePosterTitle(headline);

    return (
        <VariantWrapper data={props}>
            <TextWrapper style={{ color: 'white' }}>
                <SectionHeader title={subtitle} isShowDate={is_show_date} animated animationOffset={1} />
            </TextWrapper>

            <TextWrapper
                style={{
                    color: 'white',
                    padding: `2.6vh ${CAROUSEL_ITEM_PADDING}vh 5.21vh ${CAROUSEL_ITEM_PADDING}vh`,
                    top: `${CAROUSEL_ITEM_HEADER_HEIGHT}vh`,
                    left: 0,
                    fontSize: `${computedTitleSize.fontSize}vh`,
                    lineHeight: `${computedTitleSize.lineHeight}vh`,
                    textTransform: 'uppercase',
                    fontFamily: 'HelveticaNowDisplay',
                    fontWeight: '500',
                }}
            >
                <GradualSpacing text={headline} offset={1} />
            </TextWrapper>
        </VariantWrapper>
    )
}
